// Icona "casetta con cuore" in stile lucide (stroke currentColor, viewBox 24).
// Usata come le altre icone dei servizi: <HouseHeartIcon className="h-5 w-5 ..." />
export const HouseHeartIcon = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.8V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.8" />
    <path d="M12 18c-1.6-1.2-3-2.35-3-3.85 0-.95.78-1.55 1.55-1.55.62 0 1.12.32 1.45.82.33-.5.83-.82 1.45-.82.77 0 1.55.6 1.55 1.55 0 1.5-1.4 2.65-3 3.85z" />
  </svg>
);

export default HouseHeartIcon;
